import { MediaContentShowcaseItem } from 'onnit-ui/lib/module/MediaContentShowcase';

const IMG_PARAMS = '?q=20&fm=png&auto=compress,format';
const ingredients: MediaContentShowcaseItem[] = [
    {
        image: `arginine.png${IMG_PARAMS}`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Arginine',
        summary: 'An amino acid that your body uses to synthesize nitric oxide.',
        detail: 'Aids aerobic endurance and time to exhaustion during exercise.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `watermelon.png${IMG_PARAMS}`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Citrulline',
        summary: 'An amino acid that was first found in watermelon.',
        detail: 'Promotes work capacity and recovery.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `mango-fruit-powder.png${IMG_PARAMS}`,
        imageWidth: 560,
        imageHeight: 560,
        alt: 'Careflow Mango Fruit Powder',
        title: 'Careflow<span class="oui-sup">&reg;</span> Mango Fruit Powder',
        summary: 'A patented blend using 100% Pure Mango Fruit Powder.',
        detail: 'Shown to support circulation through eNOS activity.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `fermented-beets.png${IMG_PARAMS}`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Fermented Beets',
        summary: 'Beets are a natural source of nitrates. When fermented, they contain even more nitrates than regular beet powder, supporting NO production in the body.',
        detail: 'Contains twice as many nitrates as regular beet powder, rounding out complete support of NO production in the body.<span class="oui-sup">&dagger;</span>',
    }
];

export default ingredients;
